import { render, staticRenderFns } from "./KeywiForm.vue?vue&type=template&id=8c6e71b4&"
import script from "./KeywiForm.vue?vue&type=script&lang=ts&"
export * from "./KeywiForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports